export const origins = {
    DIGITAL_V2: 'Digital V2',
    MI_TIENDA: 'MiTienda',
    MOMO: 'MOMO'
}